import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Dienst} from '../../dienst/dienst';
import {Categorie} from '../../dienst/categorie';
import {Taak, TaakType} from '../../dienst/taak';
import {Prestatie} from '../prestatie';
import UitgevoerdeTaak from '../uitgevoerde-taak';
import {TaakGeschiedenis} from '../../taakgeschiedenis/taak-geschiedenis';
import {PrestatieTakenSelectComponent} from './taken-select/prestatie-taken-select.component';
import {TaakTipAantal} from '../../tip/taak-tip-aantal';

@Component({
    selector: 'zah-prestatie-taken',
    templateUrl: './prestatie-taken.component.html',
    styleUrls: ['./prestatie-taken.component.scss'],
    standalone: false
})
export class PrestatieTakenComponent {

  @Input()
  prestatie: Prestatie;
  @Input()
  taakGeschiedenis: TaakGeschiedenis;
  @Input()
  dienst: Dienst;
  @Input()
  taakTipAantallen: Array<TaakTipAantal>;
  @Output()
  dienstenClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  stopClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  meldingenClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  signaalkaartenClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  clientFicheClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  taakSelected: EventEmitter<UitgevoerdeTaak> = new EventEmitter<UitgevoerdeTaak>();
  @Output()
  taakDeselected: EventEmitter<UitgevoerdeTaak> = new EventEmitter<UitgevoerdeTaak>();
  @Output()
  tipsOpened: EventEmitter<[string, string, string]> = new EventEmitter<[string, string, string]>();

  @ViewChild(PrestatieTakenSelectComponent)
  private prestatieTakenSelectComponent: PrestatieTakenSelectComponent;

  categorie: Categorie;
  taken: Array<Taak>;

  onDienstenClicked(): void {
    this.dienstenClicked.emit();
  }

  onStopClicked(): void {
    this.stopClicked.emit();
  }

  onMeldingenClicked(): void {
    this.meldingenClicked.emit();
  }

  onSignaalkaartenClicked(): void {
    this.signaalkaartenClicked.emit();
  }
  onClientFicheClicked(): void {
    this.clientFicheClicked.emit();
  }

  openCategory([taakType, categorie]: [TaakType, Categorie]): void {
    this.categorie = categorie;
    this.taken = categorie.getTakenByType(taakType);
    this.prestatieTakenSelectComponent?.scrollTop();
  }

  onTaakSelect(uitgevoerdeTaak: UitgevoerdeTaak): void {
    this.taakSelected.emit(uitgevoerdeTaak);
  }

  onTaakDeselect(uitgevoerdeTaak: UitgevoerdeTaak): void {
    this.taakDeselected.emit(uitgevoerdeTaak);
  }

  onTipsOpened([dienstId, categorieId, taakId]: [string, string, string]): void {
    this.tipsOpened.emit([dienstId, categorieId, taakId]);
  }
}
